import axios, {
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import {
  baseApiUrl,
} from 'env';
// @INFO: !!! uncomment if you need to mock API
// eslint-disable-next-line import/no-extraneous-dependencies
// import MockAdapter from 'axios-mock-adapter';
// mock samples below
axios.defaults.headers.common['app-source'] = 'IntakeApp';
export const axiosInstance = axios.create({ baseURL: baseApiUrl });
const axiosExternalInstance = axios.create();
const mockedUrls = new Set<string>([]);

export function sendRequest<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> {
  const httpClient = mockedUrls.has(config.url?.toLowerCase() ?? '')
    ? axiosExternalInstance
    : axiosInstance;
  const source = axios.CancelToken.source();
  const promise = httpClient({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }: AxiosResponse<T>) => data);
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled.');
  };
  return promise;
}

// @INFO: !!! uncomment if you need to mock API
// const mockHttpAdapter = new MockAdapter(axiosMockInstance);
// e.g
// mockHttpAdapter
//   .onPost('/api/EFax/GetFaxes')
//   .reply(200, faxList);
